import { useEffect, useState } from "react";

export type VideoFitMode = "fit" | "fill";

const STORAGE_KEY = "canvas-video-fit-mode";
const EVENT_NAME = "canvas-video-fit-mode-change";

export function getVideoFitMode(): VideoFitMode {
  if (typeof window === "undefined") return "fit";
  const v = window.localStorage.getItem(STORAGE_KEY);
  return v === "fill" ? "fill" : "fit";
}

export function setVideoFitMode(mode: VideoFitMode) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, mode);
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: mode }));
}

export function useVideoFitMode(): [VideoFitMode, (mode: VideoFitMode) => void] {
  const [mode, setMode] = useState<VideoFitMode>(() => getVideoFitMode());

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<VideoFitMode>).detail;
      if (detail === "fit" || detail === "fill") setMode(detail);
    };
    window.addEventListener(EVENT_NAME, handler as EventListener);
    return () => window.removeEventListener(EVENT_NAME, handler as EventListener);
  }, []);

  return [mode, setVideoFitMode];
}